export default __webpack_public_path__ + "static/media/E-WEB-Goal-01.2869a969.png";